import { render, staticRenderFns } from "./CardSubtitle.vue?vue&type=template&id=49c39b48&"
import script from "./CardSubtitle.vue?vue&type=script&lang=js&"
export * from "./CardSubtitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports